var EEmotePackageType;

(function (EEmotePackageType) {
  EEmotePackageType[EEmotePackageType["Small"] = 1] = "Small";
  EEmotePackageType[EEmotePackageType["Big"] = 2] = "Big"; // eslint-disable-next-line no-magic-numbers

  EEmotePackageType[EEmotePackageType["Text"] = 3] = "Text";
})(EEmotePackageType || (EEmotePackageType = {}));

export { EEmotePackageType };
